export const infinityLoader = require("../assets/image/Infinity-loader.gif");
